// Класи еквівалентності для розумного пошуку: слова, що означають одне й
// те саме в UA/RU/EN автослензі. Порівняння завжди йде по стемах
// (stemWord), тому сюди достатньо писати початкові форми; збіг далі
// перевіряється префіксним правилом, тож «двигуна» знайде і «двигун»,
// і «двигатель» через клас. Словники груп запчастин (parts-classifier.ts)
// покривають специффику груп — тут тільки наскрізні поняття.
import { stemWord } from './stem.js';
const RAW_SYNONYM_GROUPS = [
    ['двигун', 'двигатель', 'мотор', 'двигло', 'engine', 'motor', 'двс'],
    ['двер', 'дверь', 'дверц', 'door'],
    ['капот', 'bonnet', 'hood'],
    ['бампер', 'bumper'],
    ['скло', 'стекло', 'glass'],
    ['дзеркало', 'зеркало', 'mirror'],
    ['фара', 'headlight', 'headlamp'],
    ['крило', 'крыло', 'fender', 'wing'],
    ['стійка', 'стойка', 'strut'],
    ['амортизатор', 'shock', 'shocker'],
    ['пружина', 'spring'],
    ['коробка', 'кпп', 'gearbox', 'transmission'],
    ['зчеплення', 'сцепление', 'clutch'],
    ['маховик', 'flywheel'],
    ['радіатор', 'радиатор', 'radiator'],
    ['помпа', 'насос', 'pump'],
    ['стартер', 'starter'],
    ['генератор', 'generator', 'альтернатор', 'alternator', 'гена'],
    ['турбіна', 'турбина', 'turbo', 'turbine'],
    ['свічка', 'свеча', 'spark'],
    ['акумулятор', 'акб', 'battery', 'батарея'],
    ['салон', 'интерьер', 'интерʼєр'],
    ['сидіння', 'сиденье', 'seat'],
    ['кермо', 'руль', 'steering'],
    ['колесо', 'wheel'],
    ['покришка', 'шина', 'tire', 'tyre', 'резина', 'гума'],
    ['гальмо', 'тормоз', 'brake'],
    ['колодка', 'pad'],
    ['ступиця', 'ступица', 'hub'],
    ['шарова', 'шаровой', 'balljoint'],
    ['важіль', 'рычаг', 'arm'],
    ['тяга', 'rod', 'link'],
    ['наконечник', 'tierod'],
    ['сайлентблок', 'bushing', 'сайлент', 'резинка'],
    ['підшипник', 'подшипник', 'bearing'],
    ['картер', 'carter', 'піддон', 'поддон'],
    ['багажник', 'trunk'],
    ['кришка', 'крышка', 'cover', 'cap'],
    ['вихлоп', 'выхлоп', 'exhaust', 'випуск', 'выпуск'],
    ['глушник', 'глушитель', 'muffler'],
    ['каталізатор', 'катализатор', 'catalyst', 'ката'],
    ['котушка', 'катушка', 'coil'],
    ['дросель', 'дроссель', 'throttle', 'заслонка', 'заслінка'],
    ['форсунка', 'инжектор', 'інжектор', 'injector', 'nozzle'],
    ['карбюратор', 'carburetor'],
    ['дрот', 'провод', 'wire', 'проводка', 'коса'],
    ['ремінь', 'ремень', 'belt'],
    ['ланцюг', 'цепь', 'chain'],
    ['ролик', 'pulley', 'tensioner'],
    ['поршень', 'piston', 'поршнева'],
    ['колінвал', 'коленвал', 'crankshaft', 'колено'],
    ['розподілвал', 'распредвал', 'camshaft'],
    ['блок', 'block'],
    ['головка', 'гбц', 'head', 'башка'],
    ['прокладка', 'gasket'],
    ['сальник', 'seal'],
    ['фільтр', 'фильтр', 'filter'],
    ['бак', 'tank', 'бензобак'],
    ['замок', 'lock', 'личинка'],
    ['обшивка', 'обшив', 'trim'],
    ['торпеда', 'торпедо', 'dash', 'борода'],
    ['педаль', 'pedal'],
    ['склопідйомник', 'стеклоподъемник', 'window'],
    ['щітка', 'щетка', 'wiper', 'дворник', 'склоочисник'],
    ['кондиціонер', 'кондиционер', 'клімат', 'кондей'],
    ['випарник', 'испаритель', 'evaporator'],
    ['печка', 'пічка', 'печь', 'heater', 'опалювач'],
    ['термостат', 'thermostat'],
    ['суппорт', 'caliper'],
    ['шланг', 'hose'],
    ['рейка', 'rack'],
    ['гур', 'гидроусилитель', 'гідропідсилювач', 'гидрач', 'гідрач'],
    ['підвіска', 'подвеска', 'suspension'],
    ['ходова', 'ходовая', 'ходовка'],
    ['оптика', 'оптика', 'light'],
    ['лобов', 'windshield', 'лобовое', 'лобовуха', 'лобовик'],
    ['дах', 'крыша', 'roof'],
    ['порог', 'порог', 'sill'],
    ['арка', 'arch'],
    ['бачок', 'reservoir'],
    ['абсорбер', 'адсорбер', 'absorber'],
    // --- Сленг запчастин (двигун/трансмісія/вихлоп) ---
    ['шрус', 'граната', 'шарнір'],
    ['бендикс', 'втягуюче', 'втягивающее'],
    ['вкладиш', 'вкладыш'],
    ['гільза', 'гильза'],
    ['інтеркулер', 'интеркулер', 'intercooler'],
    ['егр', 'egr'],
    ['впуск', 'впускний', 'впускной', 'intake'],
    ['колектор', 'коллектор', 'manifold'],
    ['банка', 'резонатор', 'паук', 'пламегаситель'],
    ['корзина', 'basket'],
    ['вижимний', 'выжимной'],
    ['роздатка', 'раздатка'],
    ['хрестовина', 'крестовина'],
    ['трамблер', 'трамблёр', 'трамбльор', 'distributor'],
    // --- Електрика / датчики ---
    ['лямбда', 'lambda'],
    ['датчик', 'сенсор', 'sensor'],
    ['рампа', 'rail'],
    ['мозки', 'мозги', 'ебу', 'эбу', 'ecu'],
    ['айрбаг', 'airbag', 'ейрбег'],
    ['абс', 'abs'],
    ['гідроблок', 'гидроблок'],
    ['вентилятор', 'fan'],
    ['компресор', 'компрессор'],
    // --- Кузов / оптика / скло ---
    ['поворотець', 'поворотник', 'мігачок', 'мигачок'],
    ['птф', 'туманка', 'противотуманка'],
    ['фонар', 'фонарь'],
    ['обвіс', 'обвес'],
    ['спойлер', 'spoiler'],
    ['морда', 'передок'],
    ['козирок', 'козырек'],
    // --- Підвіска / ходова ---
    ['лінк', 'линк'],
    // --- Колеса ---
    ['литі', 'литье', 'литые', 'ковка', 'ковані', 'кованые'],
    ['штамповка', 'штамп'],
    // --- Аксесуари / захист ---
    ['локер', 'подкрылок', 'підкрылок'],
    ['бризковик', 'брызговик'],
    ['кенгурятник', 'кенгурин'],
    ['фаркоп', 'towbar'],
    ['рейлінг', 'рейлинг'],
    ['захист', 'защита'],
    ['трапеція', 'трапеция'],
    ['омивач', 'омыватель'],
    ['підголовник', 'подголовник'],
    ['чохол', 'чехол'],
    ['килимок', 'коврик'],
    // --- EV-сленг (ніша «китайці + електро/Leaf»; складено за реальними
    //     заголовками/описами OLX+RIA з мастер-PG, barter-010) ---
    // ВВБ = високовольтна батарея («шини високовольтної батареї»);
    // «високовольтної» окремо: після ї→і стеммер дає «високовольтно»
    ['ввб', 'високовольтна', 'високовольтної', 'высоковольтная'],
    // зарядне обладнання: «зарядка» ~ «зарядний пристрій» ~ «зарядное
    // устройство» ~ «зарядник» ~ charger (десятки оголошень)
    ['зарядка', 'зарядник', 'зарядне', 'зарядное', 'charger'],
    // ОВС = бортовий зарядний пристрій (onboard charger)
    ['овс', 'obc', 'onboard'],
    // тяговий електродвигун («Электродвигатель мотор 80 кВт EM57»);
    // «електродвигатель» — гібридне написання з реальних заголовків OLX
    ['електромотор', 'электромотор', 'електродвигун', 'электродвигатель', 'електродвигатель'],
    // інвертор/DC-DC («Инвертор тока преобразователь зарядно»)
    ['інвертор', 'инвертор', 'перетворювач', 'преобразователь'],
    // осередок батареї («Ячейка батареї 62 кВт Nissan Leaf ZE1»)
    ['ячейка', 'комірка', 'cell'],
    // BMS — система менеджменту батареї («з платою BMS»)
    ['bms', 'бмс'],
    // CHAdeMO — роз'єм швидкої зарядки Leaf (кирилицею пишуть «чадемо»)
    ['chademo', 'чадемо'],
];
/** стем → список стемів класу (включно з власним) */
const synonymIndex = new Map();
for (const group of RAW_SYNONYM_GROUPS) {
    const stems = [...new Set(group.map((w) => stemWord(w.trim())))].filter(Boolean);
    for (const stem of stems) {
        const existing = synonymIndex.get(stem);
        // об'єднання класів, якщо стем випадково потрапив у два
        const merged = existing ? [...new Set([...existing, ...stems])] : stems;
        synonymIndex.set(stem, merged);
    }
}
// Другий прохід: після злиття класів розтягуємо фінальні списки на всі ключі,
// щоб кожен стем класу бачив повний набір еквівалентів
for (const [stem, stems] of [...synonymIndex.entries()]) {
    const full = new Set(stems);
    for (const s of stems) {
        for (const x of synonymIndex.get(s) ?? [s])
            full.add(x);
    }
    synonymIndex.set(stem, [...full]);
}
/** Усі еквівалентні стеми для слова запиту (сам стем + клас синонімів). */
export function synonymsFor(word) {
    const stem = stemWord(word);
    return synonymIndex.get(stem) ?? [stem];
}
//# sourceMappingURL=synonyms.js.map